import { Component, OnInit, OnDestroy, Renderer2, Input } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { MenuItem } from 'primeng/primeng';
import { Router } from '@angular/router';
import { RegistrationService } from '../services/registration.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  responseList: any;
  public advtList = [];
  displayForm: boolean;
  //advId:any;
  //advName:any;
  advt: any;
  msgs: Message[] = [];
  erroralert:boolean = false;
  errmsg:any;

  currentYear: number = new Date().getFullYear();

  displayApplicantForm: boolean;
  application: any;
  public applicantionList = [];
  appResponseList: any;

  constructor(private renderer: Renderer2, private registrationService: RegistrationService, private router: Router) {
    this.renderer.addClass(document.body, 'login-body');
  }

  ngOnInit() {
      localStorage.clear();
    this.loginForm = new FormGroup({
      codeNumber: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    });
    this.advt = 0;
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const data = this.loginForm.value;
      this.registrationService.staffLogin(data).then(res => {
        this.responseList = res;
        if (this.responseList.status == 'success') {
            this.erroralert= false;
            // console.log(this.responseList.usertype);
            if(this.responseList.usertype === 'staff'){
                localStorage.setItem('utype',this.responseList.usertype);
                localStorage.setItem('member-id', JSON.stringify(this.responseList.staffDtls.user_id));
                localStorage.setItem('user_name', JSON.stringify(this.responseList.staffDtls.user_name));
                this.displayForm = true;
                this.advtList = this.responseList.advmentlist;
            }
            else if(this.responseList.usertype === 'applicant'){
                localStorage.setItem('utype',this.responseList.usertype);
                // localStorage.setItem('userdtls', JSON.stringify(this.responseList.recDtls));
                // localStorage.setItem('photolink', this.responseList.photo);
                // localStorage.setItem('signlink', this.responseList.sign);
                // localStorage.setItem('doblink', this.responseList.dob);
                // localStorage.setItem('castelink', this.responseList.caste);
                // localStorage.setItem('phlink', this.responseList.ph);
                // localStorage.setItem('presentemployerlink', this.responseList.presentemployer);
                // localStorage.setItem('user_name', JSON.stringify(this.responseList.recDtls.name));
                // localStorage.setItem('admitsLink',this.responseList.admitsLink);
                // localStorage.setItem('challanLink',this.responseList.challanLink)
                // localStorage.setItem('advId', this.responseList.recDtls.advid);
                // localStorage.setItem('advName', this.responseList.advname);
                // localStorage.setItem('acacertlinks', JSON.stringify(this.responseList.acacertlinks));
                // this.router.navigate(['recruitment-form']);

                this.displayApplicantForm = true;
                this.applicantionList = this.responseList.applicationlist;
            }
        }
        else {
            this.erroralert= true;
            this.errmsg = this.responseList.msg;
          //alert(this.responseList.msg);
        }
      });
    } else {
      Object.keys(this.loginForm.controls).forEach(control => {
        this.loginForm.controls[control].markAsDirty();
      });
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'login-body');
  }

  selectAdvtDone() {
    if(this.advt.id == undefined){
      this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Advertisement' });
			return false;
    }
    this.displayForm = true;
    localStorage.setItem('advId', this.advt.id);
    localStorage.setItem('advName', this.advt.name);
    if(this.advt.id <= 3){
        this.router.navigate(['staff-recruitment']);
    }
    else if(this.advt.id > 3){
        this.router.navigate(['admin-staff-recruitment']);
    }

  }

// ========= Application dialog submit ======

selectApplicationDone(){
    if(this.application.id == undefined){
        this.msgs = [];
              this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Application' });
              return false;
      }else{
      this.displayApplicantForm = true;
      localStorage.setItem('applicationId', this.application.id);
      localStorage.setItem('applicationName', this.application.name);

          this.registrationService.getApplicationListService(this.application.id).then(res => {
            //   console.log(res);
              this.appResponseList = res;

            if(this.appResponseList.status === "success"){
                // console.log("working fine");
                localStorage.setItem('userdtls', JSON.stringify(this.appResponseList.recDtls));
                localStorage.setItem('photolink', this.appResponseList.photo);
                localStorage.setItem('signlink', this.appResponseList.sign);
                localStorage.setItem('doblink', this.appResponseList.dob);
                localStorage.setItem('castelink', this.appResponseList.caste);
                localStorage.setItem('phlink', this.appResponseList.ph);
                localStorage.setItem('presentemployerlink', this.appResponseList.presentemployer);
                localStorage.setItem('user_name', JSON.stringify(this.appResponseList.recDtls.name));
                localStorage.setItem('admitsLink',this.appResponseList.admitsLink);
                localStorage.setItem('challanLink',this.appResponseList.challanLink)
                localStorage.setItem('advId', this.appResponseList.recDtls.advid);
                localStorage.setItem('advName', this.appResponseList.advname);
                localStorage.setItem('acacertlinks', JSON.stringify(this.appResponseList.acacertlinks));

                this.router.navigate(['recruitment-form']);
            }

          });

      }
}

// ========= Application dialog submit end ======

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts